import { compose, lifecycle, withState, branch, renderNothing, withHandlers } from 'recompose'
import isEqual from 'lodash/isEqual'
import { rest, isApiError } from 'services'
import MarketingContent from './MarketingContent'

const withContentState = withState('content', 'setContent', null)

const withGetMarketingContentHandler = withHandlers({
  getMarketingContentHandler: ({ type, id, setContent }) => () => {
    rest.api.getMarketingContent({ urlKeys: { id, type }}).then(({ marketingContentDetails }) => {
      setContent(marketingContentDetails)
    }).catch(err => {
      if (isApiError(err)) {
        console.error(err)
      }
    })
  } })

const withLifeCycle = lifecycle({
  componentDidMount() {
    const { getMarketingContentHandler, id, type } = this.props
    if (id && type) {
      getMarketingContentHandler()
    }
  },
  componentDidUpdate({ id: prevId }) {
    const { id: newId, getMarketingContentHandler } = this.props

    if (!isEqual(prevId, newId)) {
      getMarketingContentHandler()
    }
  }
})

const withRenderNothing = branch(({ content }) => !content, renderNothing)

export default compose(
  withContentState,
  withGetMarketingContentHandler,
  withLifeCycle,
  withRenderNothing
)(MarketingContent)
